import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from '../entities/types/EntityCollectionState';
import { singleEntityDefaultState, SingleEntityState } from '../entities/types/SingleEntityState';
import {
    FAILURE_FETCH_ABO_SUBSCRIPTION_ORDER_PRODUCTS,
    FAILURE_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID,
    FAILURE_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID_AND_FILTER,
    FAILURE_FETCH_ABO_TEMPLATE_BY_ID,
    FAILURE_INSERT_ABO_SUBSCRIPTION,
    FAILURE_UPDATE_ABO_SUBSCRIPTION,
    REQUEST_FETCH_ABO_SUBSCRIPTION_ORDER_PRODUCTS,
    REQUEST_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID,
    REQUEST_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID_AND_FILTER,
    REQUEST_FETCH_ABO_TEMPLATE_BY_ID,
    REQUEST_INSERT_ABO_SUBSCRIPTION,
    REQUEST_UPDATE_ABO_SUBSCRIPTION,
    SUCCESS_FETCH_ABO_SUBSCRIPTION_ORDER_PRODUCTS,
    SUCCESS_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID,
    SUCCESS_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID_AND_FILTER,
    SUCCESS_FETCH_ABO_TEMPLATE_BY_ID,
    SUCCESS_INSERT_ABO_SUBSCRIPTION,
    SUCCESS_UPDATE_ABO_SUBSCRIPTION,
} from './actions';

export function aboTemplatesReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case REQUEST_INSERT_ABO_SUBSCRIPTION:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_INSERT_ABO_SUBSCRIPTION:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_INSERT_ABO_SUBSCRIPTION:
            return _.assign({}, state, { isFetching: false, error: action.error });

        case REQUEST_UPDATE_ABO_SUBSCRIPTION:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_UPDATE_ABO_SUBSCRIPTION:
            return _.assign({}, state, { isFetching: false, error: undefined });
        case FAILURE_UPDATE_ABO_SUBSCRIPTION:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}

export function aboFilteredTemplatesReducer(
    state: SingleEntityState<any> = singleEntityDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID_AND_FILTER:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID_AND_FILTER:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_FETCH_ABO_TEMPLATES_BY_CUSTOMER_ID_AND_FILTER:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}

export function aboSubscriptionOrderProductsReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_FETCH_ABO_SUBSCRIPTION_ORDER_PRODUCTS:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_FETCH_ABO_SUBSCRIPTION_ORDER_PRODUCTS:
            return _.assign({}, state, { isFetching: false, items: action.response.data, error: undefined });
        case FAILURE_FETCH_ABO_SUBSCRIPTION_ORDER_PRODUCTS:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

export function aboTemplateReducer(state: SingleEntityState<any> = singleEntityDefaultState(), action: AnyAction) {
    switch (action.type) {
        case REQUEST_FETCH_ABO_TEMPLATE_BY_ID:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_FETCH_ABO_TEMPLATE_BY_ID:
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        case FAILURE_FETCH_ABO_TEMPLATE_BY_ID:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        default:
            return state;
    }
}
